export const INVOICE_TYPE = {
  VAT: 'vat',
  PROFORMA: 'proforma',
  CORRECTION: 'correction',
  CLIENT_ORDER: 'client_order',
};

export type InvoiceType = ValueOf<typeof INVOICE_TYPE>;
